module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    staticStyle: {
      "background-color": "rgba(250, 250, 250, 1)"
    }
  }, [_c('div', {
    staticClass: "page-progress flex-col"
  }, [_c('div', {
    staticClass: "flex-col justify-between"
  }, [_c('div', {
    staticClass: "mod4 flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('experiment-header', {
    attrs: {
      "contractNo": _vm.contractNo,
      "status": _vm.status
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, _vm._l((_vm.taskModules), function(task, index) {
    return _c('div', {
      key: index,
      staticClass: "historyProgress",
      staticStyle: {
        "display": "flex"
      },
      style: (task.publishComments.length < 1 ? {
        height: '19.5vw'
      } : {})
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "margin-left": "15px",
        "flex-direction": "column"
      }
    }, [_c('div', {
      staticStyle: {
        "line-height": "14px"
      }
    }, [(
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ENDING
    ) ? _c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("对勾#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -198.000000)",
        "fill": "#5878FA",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "对勾#merge#",
        "transform": "translate(28.000000, 198.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z",
        "id": "形状"
      }
    })])])])]) : _vm._e(), _vm._v(" "), (
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START
    ) ? _c('div', {
      staticClass: "colorDiv_2 left1",
      staticStyle: {
        "index < taskModules.length -1 ? {'margin'": "'0 auto'}"
      }
    }) : _vm._e(), _vm._v(" "), (task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_ON_GOING) ? _c('svg', {
      staticClass: "left1",
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("编组#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "课题组",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-病毒",
        "transform": "translate(-28.000000, -270.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "编组#merge#",
        "transform": "translate(28.000000, 270.000000)"
      }
    }, [_c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#5878FA",
        "cx": "7",
        "cy": "7",
        "r": "7"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形",
        "fill": "#FFFFFF",
        "cx": "7",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份",
        "fill": "#FFFFFF",
        "cx": "9.8",
        "cy": "7",
        "r": "1"
      }
    }), _vm._v(" "), _c('circle', {
      attrs: {
        "id": "椭圆形备份-2",
        "fill": "#FFFFFF",
        "cx": "4.2",
        "cy": "7",
        "r": "1"
      }
    })])])])]) : _vm._e(), _vm._v(" "), (task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP) ? _c('svg', {
      attrs: {
        "width": "14px",
        "height": "14px",
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("关闭")]), _vm._v(" "), _c('g', {
      attrs: {
        "id": "进展查询",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "进展查询-服务类-实验进展备份-2",
        "transform": "translate(-25.000000, -306.000000)",
        "fill-rule": "nonzero"
      }
    }, [_c('g', {
      attrs: {
        "id": "关闭",
        "transform": "translate(25.000000, 306.000000)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0,7 L0,7 C0,10.8659961 3.13400391,14 7,14 C10.8659961,14 14,10.8659961 14,7 L14,7 C14,3.13400391 10.8659961,0 7,0 C3.13400391,0 0,3.13400391 0,7 L0,7 Z",
        "id": "路径",
        "fill": "#F55300"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M3.2329342,4.3118086 L9.70694355,10.7858173 L9.70694356,10.7858173 C10.0100447,11.0785629 10.4930724,11.0701669 10.7858179,10.7670657 C11.071394,10.4713874 11.071394,10.0026212 10.7858179,9.7069429 L4.31180858,3.23293416 L4.31180861,3.2329342 C4.01906457,2.92983312 3.53603532,2.9214372 3.23293422,3.21418241 C2.92983312,3.50692643 2.9214372,3.98995563 3.21418244,4.29305671 C3.22032389,4.29941542 3.22657539,4.30566692 3.23293407,4.31180834 L3.2329342,4.3118086 Z",
        "id": "路径",
        "fill": "#F9F9F9"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M3.23264301,9.6897523 L9.69864387,3.22344586 L9.69864381,3.22344592 C9.99619785,2.92566646 10.4787993,2.92549677 10.7765646,3.22306477 C11.07433,3.52063287 11.0744997,4.00325708 10.7769458,4.30103654 L4.31018584,10.767343 L4.31018588,10.7673429 C4.01780396,11.0700834 3.53537224,11.0784693 3.23264608,10.7860724 C2.92991991,10.4936767 2.92153438,10.0112221 3.21391749,9.70848168 C3.22005104,9.70213085 3.22629449,9.69588708 3.23264503,9.68975325 L3.23264301,9.6897523 Z",
        "id": "路径",
        "fill": "#F9F9F9"
      }
    })])])])]) : _vm._e()]), _vm._v(" "), (index < _vm.taskModules.length - 1) ? _c('div', {
      staticClass: "group22",
      class: {
        'div_2':
        task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START || task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
          task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP ||
          task.currentStatus === _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress_history",
      style: ((task.publishComments.length < 1 || (task.publishComments.length > 0 && task.publishComments[0].length < 50)) ? {
        height: '91px'
      } : {})
    }, [_c('div', {
      staticClass: "box4_text",
      style: ((task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START ||
        task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
        task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP ||
        task.currentStatus ===
        _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START) ? {
        'margin-top': '-3px'
      } : '')
    }, [_c('div', {
      staticClass: "plasmidExtraction",
      class: [
        task.publishComments.length > 0 ?
        'color_red' :
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_NOT_START &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_STOP &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_READY_START &&
        task.currentStatus !==
        _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP ?
        'color_black' :
        'color_gray' ]
    }, [_vm._v("\n                      " + _vm._s(task.taskName) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "outer_2"
    }, [_c('span', {
      staticClass: "completionTime",
      attrs: {
        "lines": undefined
      }
    }, [(
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ENDING ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP
    ) ? _c('span', [_vm._v("完成时间")]) : (
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ON_GOING
    ) ? _c('span', {
      staticClass: "color_blue"
    }, [_vm._v("开始时间")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "text",
      attrs: {
        "lines": undefined
      }
    }, [(
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ENDING ||
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_END_STOP
    ) ? _c('span', [_vm._v(_vm._s(task.actualEnd))]) : (
      task.currentStatus ===
      _vm.emkt.EXPERIMENT_MODULES_STATUS_ON_GOING
    ) ? _c('span', {
      staticClass: "color_blue"
    }, [_vm._v(_vm._s(task.actualStart))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "paragraph1",
      class: {
        'paragraph-font1': index !== 0,
          'paragraph-font2': index === 0,
      },
      style: ({
        'margin-left': index === _vm.taskModules.length - 1 ? '20px' : '10px',
      })
    }, _vm._l((task.publishComments), function(text, index) {
      return _c('span', {
        key: index,
        staticClass: "tasktext",
        staticStyle: {
          "margin-top": "5px",
          "display": "block"
        }
      }, [_vm._v("\n                      " + _vm._s(text) + "\n                      "), _c('br')])
    }), 0)])])
  }), 0)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69fd551a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceProgressRefactor/experimentDetail/index.vue
// module id = 1668
// module chunks = 8